import * as z from "zod";
import { mutator } from "./mutator";

export const declinePushLiveRequest = mutator({
  schema: z.object({ requestId: z.string() }),
  description: "Declines a teammate’s push request for their branch.",
  interactionType: "review",
  resolve: {
    request: { kind: "pushLiveRequest", from: "requestId" },
  },
  permissions: [
    {
      permission: "space:push_live",
      scopeId: ({ args }) => args.request.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { request } }) => {
    await tx.mutate.pushLiveRequests.delete({ id: request.id });
  },
});
